import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Common block',
  name: 'commonBlock',
  type: 'object',
  fields: [
    defineField({
      title: 'Common Page Reference',
      name: 'blockReference',
      type: 'reference',
      to: [{ type: 'commonPageBuilder' }],
      validation: (rule) => [
        rule.custom((field, { parent }) => {
          // Required when visible
          return parent?.component === 'commonPageBuilder' &&
            field === undefined
            ? 'Page reference is required.'
            : true
        }),
      ],
    }),
  ],
  preview: {
    select: {
      blockReferenceTitle: 'blockReference.title',
    },
    prepare({ blockReferenceTitle }) {
      return {
        title: blockReferenceTitle || 'Untitled',
        subtitle: 'Common Block',
      }
    },
  },
})